import { NO_ARGS, SINGLE_NUMERIC, SINGLE_PATTERN } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const struct: EffectEntry = {
  kind: 'struct',
  category: 'effect',
  family: 'structural',
  doc: 'apply a rhythm mask: "t ~ t t" keeps 1 and 3-4',
  args: SINGLE_PATTERN,
  toCode: () => STUB_NOT_IMPLEMENTED('struct', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('struct', 'fromAst'),
};

export const mask: EffectEntry = {
  kind: 'mask',
  category: 'effect',
  family: 'structural',
  doc: 'apply a boolean pattern: "1 0 1 1" keeps hits',
  args: SINGLE_PATTERN,
  toCode: () => STUB_NOT_IMPLEMENTED('mask', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('mask', 'fromAst'),
};

export const degrade: EffectEntry = {
  kind: 'degrade',
  category: 'effect',
  family: 'structural',
  doc: 'randomly drop 50% of events (no arg)',
  args: NO_ARGS,
  toCode: () => STUB_NOT_IMPLEMENTED('degrade', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('degrade', 'fromAst'),
};

export const degradeBy: EffectEntry = {
  kind: 'degradeBy',
  category: 'effect',
  family: 'structural',
  doc: 'randomly drop N fraction (0.25 = drop 25%)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('degradeBy', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('degradeBy', 'fromAst'),
};

export const undegrade: EffectEntry = {
  kind: 'undegrade',
  category: 'effect',
  family: 'structural',
  doc: 'inverse of degrade',
  args: NO_ARGS,
  toCode: () => STUB_NOT_IMPLEMENTED('undegrade', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('undegrade', 'fromAst'),
};

export const undegradeBy: EffectEntry = {
  kind: 'undegradeBy',
  category: 'effect',
  family: 'structural',
  doc: 'inverse of degradeBy',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('undegradeBy', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('undegradeBy', 'fromAst'),
};

export const speed: EffectEntry = {
  kind: 'speed',
  category: 'effect',
  family: 'structural',
  doc: 'sample playback speed (2 = up octave, 0.5 = down)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('speed', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('speed', 'fromAst'),
};
